import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonDataService {
  // Existing properties
  merchantId: string;
  societyId: string;
  public itemNames: any = [];
  userId: string;
  shareDataString: string;
  shareBase64: string;
  shareColor: string;
  collectionpoint_id: number;
  collectionpoint_name: string;

  // ✅ NEW: Authentication state
  isAuthenticated: boolean = false;

  constructor() { }

  /**
   * ✅ BEST PRACTICE: Set authentication state after successful login
   */
  setAuth(collectionpointId: number, collectionpointName: string, societyId: string) {
    this.collectionpoint_id = collectionpointId;
    this.collectionpoint_name = collectionpointName;
    this.societyId = societyId;
    this.isAuthenticated = true;
    
    // Set SessionStorage (clears on browser close)
    sessionStorage.setItem('isLoggedIn', 'true');
    sessionStorage.setItem('collectionpoint_id', collectionpointId.toString());
    sessionStorage.setItem('societyId', societyId);
  }

  /**
   * ✅ BEST PRACTICE: Clear ALL auth state on logout/browser close
   */
  clearAuth() {
    this.collectionpoint_id = null;
    this.collectionpoint_name = null;
    this.societyId = null;
    this.isAuthenticated = false;
    this.merchantId = null;
    this.userId = null;
    
    // Clear SessionStorage
    sessionStorage.clear();
    // OR selectively:
    // sessionStorage.removeItem('isLoggedIn');
    // sessionStorage.removeItem('collectionpoint_id');
    // sessionStorage.removeItem('societyId');
  }

  /**
   * ✅ BEST PRACTICE: Check if user is authenticated
   * Used by AuthGuard
   */
  isUserAuthenticated(): boolean {
    const isSessionValid = sessionStorage.getItem('isLoggedIn') === 'true';
    const hasRequiredData = !!this.collectionpoint_id && !!this.societyId;
    
    return isSessionValid && hasRequiredData;
  }

  /**
   * ✅ BEST PRACTICE: Restore state from SessionStorage (page refresh)
   */
  restoreAuthState() {
    const savedLogin = sessionStorage.getItem('isLoggedIn') === 'true';
    const savedCollectionpointId = sessionStorage.getItem('collectionpoint_id');
    const savedSocietyId = sessionStorage.getItem('societyId');

    if (savedLogin && savedCollectionpointId && savedSocietyId) {
      this.collectionpoint_id = Number(savedCollectionpointId);
      this.societyId = savedSocietyId;
      this.isAuthenticated = true;
    }
  }

  /**
   * ✅ BEST PRACTICE: Clear sensitive share data
   */
  clearShareData() {
    this.shareDataString = null;
    this.shareBase64 = null;
    this.shareColor = null;
  }
}
